<template>
    <Modal :title="$t('common.downloadCsvReport.modal.title')"
           :close-on-click-outside="false"
           @close="closeModal"
    >
        <template v-slot:body>
            <form class="base_margin modal-content" style="margin-top: 0">
                <DatePicker
                    v-on:input="changeDate"
                    :value="form.dateRange"
                    :placeholder="$t('common.assignmentDate')"
                    type="daterange"
                ></DatePicker>
            </form>
            <div class="flex flex_between base_margin">
                <md-button class="md-blank" @click="closeModal">
                    {{$t("common.button.close")}}
                </md-button>
                <md-button class="opacity_5" :class="{ 'md-primary': submitBtnStatus }" @click="download">
                    {{$t("common.download")}}
                </md-button>
            </div>
        </template>
    </Modal>
</template>

<script>
import DatePicker from "@/components/templates/DatePicker";
import {allReceivablesApi} from "@/common/api/allReceivablesApi";
import Modal from "@/components/templates/modal/Modal";

export default {
    props: {
        accountId: { type: Number }
    },
    components: {
        Modal,
        DatePicker
    },
    data() {
        return {
            form: {
                dateRange: ["", ""]
            },
        };
    },
    computed: {
        exportCsvUrl() {
          let option = {
            fromDate: this.form.dateRange[0],
            toDate: this.form.dateRange[1]
          };
          return allReceivablesApi.exportCsvUrl(option);
        },
        submitBtnStatus() {
            return this.form.dateRange.every(value => value !== "");
        }
    },
    methods: {
        download() {
            if (!this.submitBtnStatus) {
                return;
            }

            window.open(this.exportCsvUrl, "_blank");
            this.closeModal();
        },
        closeModal() {
            this.$emit("close");
        },
        changeDate(dateRange) {
            this.form.dateRange = dateRange;
        },
    }
};
</script>
